import PaymentForm from "components/Form/PaymentForm";

export default function PaymentStep(props) {

    const PAYMENT_TYPE = 0 // registration

    return (<PaymentForm type={PAYMENT_TYPE}/>)
}